/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Team_Access_DescriptionInputs */



/**
* | output |
* | --- |
* | "Manage which teams have access to this space" |
*
* @param {Spaces_Team_Access_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_team_access_description = /** @type {((inputs?: Spaces_Team_Access_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Team_Access_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalte, welche Teams Zugriff auf diesen Space haben")
	return /** @type {LocalizedString} */ ("Manage which teams have access to this space")
});